import React from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box, Alert, Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/** adminOnly: 관리자가 아니면 내 계정 화면으로 보낸다 */
const PrivateRoute = ({ children, adminOnly = false }) => {
  const { token, user, loading, fetchUser } = useAuth();

  if (!loading && token && !user) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <Alert severity="error" action={<Button onClick={fetchUser}>다시 시도</Button>}>
          인증 서버에 연결할 수 없습니다.
        </Alert>
      </Box>
    );
  }
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  if (!token) return <Navigate to="/login" replace />;
  if (adminOnly && !user?.isAdmin) return <Navigate to="/settings" replace />;
  return children;
};

export default PrivateRoute;
